import React, { useEffect, useState } from 'react'
import styles from './index.module.scss'
import VerificationCode from '../securityCheck/verificationCode'
import Dialog from '@/wmCompoments/dialog'
import Toast from '@/wmCompoments/toast'

interface CodeDialogProps {
  visible: boolean
  onClose?: (type?: 'success' | 'cancel' | 'colse') => void
  className?: string
  onSubmit?: (v?: string) => Promise<any>,
  text?: string
}

const CodeDialog = (props: CodeDialogProps) => {
  const { visible, onClose, text } = props

  const [value, setValue] = useState('')

  useEffect(() => {
    setValue('')
  }, [visible])

  return (
    <>
      <Dialog
        visible={visible}
        onClose={() => {
          onClose?.('colse')
        }}
        closeOnMaskClick={true}
        actions={[
          
            {
              key: 'cancel',
              text: '取消',
              onClick: () => {
                onClose?.('cancel')
              }
            },
            {
              key: 'confirm',
              text: '确认',
              onClick: async () => {
                if (value?.length < 6) {
                  Toast.show('请输入6位验证码')
                  return
                }
                await props.onSubmit?.(value)
                onClose?.('success')
              }
            }
          
        ]}
        content={
          <div className={styles.dialog_content}>
            <span>安全检测</span>
            <span>为了保障您的账户安全，请您输入六位验证码</span>
            <span>{text}</span>
            <VerificationCode
              value={value}
              onChange={(v) => setValue(v)}
              mode={'block'}
              length={6}
            />
          </div>
        }
      />
    </>
  )
}

export default CodeDialog
